module.exports = __webpack_public_path__ + "static/en-f371d3a340a1cd53db605cdfc0c8a70e.svg";